// Contrato único de teléfono (E.164) — espejo ligero del backend (shared.normalizar_telefono).
// El backend re-normaliza siempre; aquí sólo damos UX (selector país + número) y display.
export const PAISES = [
  { iso: "MX", cc: "52", nombre: "México", flag: "🇲🇽" },
  { iso: "US", cc: "1", nombre: "Estados Unidos", flag: "🇺🇸" },
  { iso: "CA", cc: "1", nombre: "Canadá", flag: "🇨🇦" },
  { iso: "ES", cc: "34", nombre: "España", flag: "🇪🇸" },
  { iso: "AR", cc: "54", nombre: "Argentina", flag: "🇦🇷" },
  { iso: "CO", cc: "57", nombre: "Colombia", flag: "🇨🇴" },
  { iso: "CL", cc: "56", nombre: "Chile", flag: "🇨🇱" },
  { iso: "PE", cc: "51", nombre: "Perú", flag: "🇵🇪" },
  { iso: "GT", cc: "502", nombre: "Guatemala", flag: "🇬🇹" },
  { iso: "GB", cc: "44", nombre: "Reino Unido", flag: "🇬🇧" },
];

const CC_ORDENADOS = [...new Set(PAISES.map((p) => p.cc))].sort((a, b) => b.length - a.length);
const isoDeCc = (cc) => (PAISES.find((p) => p.cc === cc) || {}).iso;
export const ccDeIso = (iso) => (PAISES.find((p) => p.iso === iso) || {}).cc || "52";

function agrupar(cc, nsn) {
  if ((cc === "52" || cc === "1") && nsn.length === 10) return `${nsn.slice(0, 3)} ${nsn.slice(3, 6)} ${nsn.slice(6)}`;
  return nsn;
}

// Divide un valor almacenado (display o E.164) en {pais, nacional}.
export function parseTelefono(raw, paisDefault = "MX") {
  if (!raw) return { pais: paisDefault, nacional: "" };
  const s = String(raw).trim();
  const conPlus = s.startsWith("+") || s.startsWith("00");
  const digits = (s.startsWith("00") ? s.slice(2) : s).replace(/\D/g, "");
  if (!digits) return { pais: paisDefault, nacional: "" };
  if (conPlus) {
    for (const cc of CC_ORDENADOS) {
      if (digits.startsWith(cc) && digits.length - cc.length >= 6) {
        return { pais: isoDeCc(cc) || paisDefault, nacional: digits.slice(cc.length) };
      }
    }
    return { pais: paisDefault, nacional: digits };
  }
  return { pais: paisDefault, nacional: digits };
}

// Arma el objeto a persistir. El display incluye el código internacional siempre.
export function armarTelefono(pais, nacionalRaw) {
  const cc = ccDeIso(pais);
  const nsn = String(nacionalRaw || "").replace(/\D/g, "");
  if (!nsn) return { telefono: "", telefono_pais: pais, telefono_e164: null };
  const display = `+${cc} ${agrupar(cc, nsn)}`;
  return { telefono: display, telefono_pais: pais, telefono_e164: `+${cc}${nsn}` };
}
